import adminCreateTicket from "./adminCreateTicket.api";
import getTickets from "./getTickets.api";
import getTicket from "./getTicket.api";
import acknowledgeTicket from "./acknowledgeTicket.api";
import assignTicket from "./assignTicket.api";
import escalateTicket from "./escalateTicket.api";
import updateTicketStatus from "./updateTicketStatus.api";
import updateTicketPriority from "./updateTicketPriority.api";
import addComment from "./addComment.api";
import uploadAttachment from "./uploadAttachment.api";
import getAnalyticsOverview from "./getAnalyticsOverview.api";
import getAnalyticsSla from "./getAnalyticsSla.api";
import getAgents from "./getAgents.api";
import getSlaConfigs from "./getSlaConfigs.api";
import updateSlaConfig from "./updateSlaConfig.api";
import getGlobalSlaConfigs from "./getGlobalSlaConfigs.api";
import updateGlobalSlaConfig from "./updateGlobalSlaConfig.api";
import getBusinessHours from "./getBusinessHours.api";
import updateBusinessHours from "./updateBusinessHours.api";
import getHolidays from "./getHolidays.api";
import createHoliday from "./createHoliday.api";
import updateHoliday from "./updateHoliday.api";
import deleteHoliday from "./deleteHoliday.api";
import getAutoReplies from "./getAutoReplies.api";
import updateAutoReply from "./updateAutoReply.api";
import getUnreadSummary from "./getUnreadSummary.api";

const supportApi = {
  adminCreateTicket,
  getTickets,
  getTicket,
  acknowledgeTicket,
  assignTicket,
  escalateTicket,
  updateTicketStatus,
  updateTicketPriority,
  addComment,
  uploadAttachment,
  getAnalyticsOverview,
  getAnalyticsSla,
  getAgents,
  getSlaConfigs,
  updateSlaConfig,
  getGlobalSlaConfigs,
  updateGlobalSlaConfig,
  getBusinessHours,
  updateBusinessHours,
  getHolidays,
  createHoliday,
  updateHoliday,
  deleteHoliday,
  getAutoReplies,
  updateAutoReply,
  getUnreadSummary,
};

export default supportApi;
